import { createRouter, createWebHistory } from 'vue-router'

import { checkHestiaCustomersFeatureFlag } from '@/features/app-store/router/guards/checkHestiaCustomersFeatureFlag'
import { checkHestiaLoyaltyFeatureFlag } from '@/features/app-store/router/guards/checkHestiaLoyaltyFeatureFlag'
import { checkHestiaOrdersFeatureFlag } from '@/features/app-store/router/guards/checkHestiaOrdersFeatureFlag'
import { checkGiftCardImportFeatureFlag } from '@/features/gift-cards/router/guards/checkGiftCardImportFeatureFlag'
import { checkInboxFeatureFlag } from '@/features/inbox/router/guards/checkInboxFeatureFlag'
import { checkLaunchFeatureFlag } from '@/features/launch'
import { checkMarketingOverviewV2FeatureFlag } from '@/features/marketing/router/guards/checkMarketingOverviewV2FeatureFlag'
import { checkMenuScorecardFeatureFlag } from '@/features/menu/router/guards/checkMenuScorecardFeatureFlag'
import { checkMenuFixerAgentFeatureFlag } from '@/features/menu-fixer-agent/router/guards/checkMenuFixerAgentFeatureFlag'
import { checkGuestPhotoReviewerFeatureFlag } from '@/features/photo-moderation/router/guards/checkGuestPhotoReviewerFeatureFlag'
import { checkSalesFeatureFlag } from '@/features/sales/router/guards/checkSalesFeatureFlag'
import { checkLegacyGuestImportRedirect } from '@/features/setup/router/guards/checkLegacyGuestImportRedirect'
import { checkPhoneOrderingFeatureFlag } from '@/features/tools/router/guards/checkPhoneOrderingFeatureFlag'

import { checkAuthenticated } from './guards/checkAuthenticated'
import { checkBrandAccess } from './guards/checkBrandAccess'
import { checkPermissions } from './guards/checkPermissions'
import { ensureLocationIdParam } from './guards/ensureLocationIdParam'
import { handleAfterEach } from './handleAfterEach'
import routes from './routes'

export const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'is-active',
  routes,
})

const guards = [
  checkAuthenticated,
  checkPermissions,
  checkBrandAccess,
  checkGiftCardImportFeatureFlag,
  checkGuestPhotoReviewerFeatureFlag,
  checkHestiaCustomersFeatureFlag,
  checkHestiaLoyaltyFeatureFlag,
  checkHestiaOrdersFeatureFlag,
  checkInboxFeatureFlag,
  checkLegacyGuestImportRedirect,
  checkMarketingOverviewV2FeatureFlag,
  checkMenuFixerAgentFeatureFlag,
  checkMenuScorecardFeatureFlag,
  checkPhoneOrderingFeatureFlag,
  checkSalesFeatureFlag,
  checkLaunchFeatureFlag,
  ensureLocationIdParam,
]

router.beforeEach(async (to, from) => {
  for (const guard of guards) {
    const redirect = await guard(to, from)
    if (redirect) return redirect
  }
})

router.afterEach(handleAfterEach)
